/******/ (() => {
  // webpackBootstrap
  /* eslint-disable */
  if (!customElements.get("product-quick-buy")) {
    customElements.define(
      "product-quick-buy",
      class ProductQuickBuy extends HTMLElement {
        constructor() {
          super();
          this.dataCache = new Map(); // Cache for pre-fetched data
          this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
          this.init();
        }

        init() {
          this.cacheDOMElements();
          this.bindEventHandlers();
        }

        getQuickBuyModule() {
          return (
            this._portalWrapper ||
            this.querySelector(".product-grid__quick-buy__module")
          );
        }

        queryInModule(selector) {
          const module = this.getQuickBuyModule();
          return module?.querySelector(selector) ?? null;
        }

        queryAllInModule(selector) {
          const module = this.getQuickBuyModule();
          return module
            ? Array.from(module.querySelectorAll(selector))
            : [];
        }

        cacheDOMElements() {
          /* ===== Cache any information that we'll need later ===== */
          this.sectionId = this.getAttribute("data-section-id");
          this.originalSectionId = this.getAttribute(
            "data-original-section-id"
          );
          this.isQuickView = this.dataset.quickView === "true";
          this.productForm = this.querySelector("product-form");
          this.stickyContainer = this.classList.contains("product-sticky")
            ? this
            : null;
          this.stickyHeader = document.querySelector(".header-section");
          this.enableURLUpdate = this.dataset.enableUrlUpdate === "true";
          this.mainProductURL = this.dataset.url;
          this.isGridItem = this.dataset.isGridItem === "true";
          this.wording = this.dataset.wordingAddToCart;
          this.openQuickBuy = this.querySelector(".quickAddJs");
          this.closeQuickBuy = this.querySelector(".quickAddCloseJs");
          this.colorIds = this.getAttribute("data-color-ids");
        }

        connectedCallback() {
          /* ===== Gather options for the current variant, handle sticky form offset, attach event listeners ===== */
          this.setStickyOffset();
          this.attachEventListeners();
          this.isCombinedListing = this.dataset.isCombinedListing === "true";
        }

        disconnectedCallback() {
          /* ===== Clean up event listeners ===== */
          this.removeEventListeners();
        }

        bindEventHandlers() {
          /* ===== Bind methods to maintain the 'this' context ===== */
          this.resizeHandler = this.handleResize.bind(this);
          this.onQuantityChange = this.handleQuantityChange.bind(this);
          this.onVariantChange = this.handleVariantChange.bind(this);
          this.prefetchVariantData = this.prefetchVariantData.bind(this);
        }

        attachEventListeners() {
          // On resize we need to update the sticky form offset
          window.addEventListener("resize", this.resizeHandler);
          // Listen for quantity changes
          eventBus.on("qty:change", this.onQuantityChange);
          // Listen for variant changes
          eventBus.on("variant:change", this.onVariantChange);
          eventBus.on("cart:added", this.closeQuickBuyModal.bind(this));
          eventBus.on("cart:added", this.openAsideCart.bind(this));
          if (this.openQuickBuy) {
            this.openQuickBuy.addEventListener(
              "click",
              this.openQuickBuyModal.bind(this)
            );
          }
          if (this.closeQuickBuy) {
            this.closeQuickBuy.addEventListener(
              "click",
              this.closeQuickBuyModal.bind(this)
            );
          }
          // Prefetch variant data
          //this.addEventListener('mouseover', this.prefetchVariantData);
          //this.addEventListener('touchstart', this.prefetchVariantData);
        }

        removeEventListeners() {
          /* ===== Remove any event listeners we've attached ===== */
          window.removeEventListener("resize", this.resizeHandler);
          eventBus.off("qty:change", this.onQuantityChange);
          eventBus.off("variant:change", this.onVariantChange);
          eventBus.off("cart:added", this.closeQuickBuyModal.bind(this));
          if (this.openQuickBuy) {
            this.openQuickBuy.removeEventListener(
              "click",
              this.openQuickBuyModal.bind(this)
            );
          }
          if (this.closeQuickBuy) {
            this.closeQuickBuy.removeEventListener(
              "click",
              this.closeQuickBuyModal.bind(this)
            );
          }
          //this.removeEventListener('mouseover', this.prefetchVariantData);
          //this.removeEventListener('touchstart', this.prefetchVariantData);
        }

        openQuickBuyModal() {
          const wrapper = this.getQuickBuyModule();
          if (!wrapper) return;
          const parentCard = this.closest(".product-card-wrapper");

          // Keep a back-reference when the module is portaled outside this element.
          wrapper._productQuickBuyHost = this;

          // On mobile, overflow/stacking contexts on the card break position:fixed
          // and disconnect swatch events from product-quick-buy. Portal to body.
          const isMobile = window.innerWidth < 750;
          if (isMobile && wrapper.parentNode !== document.body) {
            this._portalParent = wrapper.parentNode;
            this._portalNextSibling = wrapper.nextSibling;
            this._portalWrapper = wrapper;
            document.body.appendChild(wrapper);
          }

          // Close when clicking the backdrop (the ::before pseudo-element area)
          this._backdropHandler = (e) => {
            const rect = wrapper.getBoundingClientRect();
            if (e.clientY < rect.top) {
              this.closeQuickBuyModal();
            }
          };
          wrapper.addEventListener("click", this._backdropHandler);

          wrapper.classList.add("show");
          if (parentCard) {
            parentCard.classList.add("quick-buy-open");
          }
          const parentSection = this.closest("section.shopify-section");
          const parentPage = this.closest(".page-product");
          if (parentSection) {
            parentSection.classList.add("quick-buy-open");
          }
          if (parentPage) {
            parentPage.classList.add("quick-buy-open");
          }
        }

        closeQuickBuyModal() {
          // Use portaled reference if available (module may have been moved to document.body)
          const wrapper =
            this._portalWrapper ||
            this.querySelector(".product-grid__quick-buy__module");
          if (!wrapper) return;
          const parentCard = this.closest(".product-card-wrapper");

          // Remove backdrop listener
          if (this._backdropHandler) {
            wrapper.removeEventListener("click", this._backdropHandler);
            this._backdropHandler = null;
          }

          wrapper.classList.remove("show");
          if (parentCard) {
            parentCard.classList.remove("quick-buy-open");
          }

          // Restore the module to its original DOM position after portaling
          if (this._portalParent && wrapper.parentNode === document.body) {
            this._portalParent.insertBefore(wrapper, this._portalNextSibling);
            this._portalParent = null;
            this._portalNextSibling = null;
            this._portalWrapper = null;
          }

          const parentSection = this.closest("section.shopify-section");
          const parentPage = this.closest(".page-product");
          if (parentSection) {
            parentSection.classList.remove("quick-buy-open");
          }
          if (parentPage) {
            parentPage.classList.remove("quick-buy-open");
          }
        }

        openAsideCart() {
          if (this.cart) {
            this.cart.open();
          }
        }

        prefetchVariantData() {
          const variants = this.querySelectorAll("[data-product-variant]");
          if (!variants.length) return;

          variants.forEach((variant) => {
            const productFetchUrl = variant.getAttribute(
              "data-product-fetch-url"
            );

            if (productFetchUrl && !this.dataCache.has(productFetchUrl)) {
              this.fetchProductData(productFetchUrl).catch((error) => {
                console.error(
                  `Failed to fetch data for ${productFetchUrl}:`,
                  error
                );
              });
            }
          });
        }

        buildSectionFetchUrl(productFetchUrl) {
          const sectionId = "product-quick-buy-content";
          const separator = productFetchUrl.includes("?") ? "&" : "?";
          return `${productFetchUrl}${separator}section_id=${sectionId}`;
        }

        async fetchProductData(productFetchUrl) {
          try {
            const response = await fetch(
              this.buildSectionFetchUrl(productFetchUrl)
            );
            if (!response.ok) {
              throw new Error(
                `Network response was not ok for ${productFetchUrl}`
              );
            }
            const data = await response.text();
            const productData = this.extractProductData(data);
            this.dataCache.set(productFetchUrl, productData);
          } catch (error) {
            console.error(
              `Failed to fetch product data from ${productFetchUrl}:`,
              error
            );
          }
        }

        setVariantLoadingState(isLoading) {
          const addButton = this.queryInModule('[type="submit"][name="add"]');
          const module = this.getQuickBuyModule();

          if (isLoading) {
            this.classList.add("loading");
            module?.classList.add("is-loading");
            if (!addButton) return;

            addButton.classList.add("loading");
            addButton.disabled = true;
            addButton.setAttribute("aria-busy", "true");

            const addToCartText = addButton.querySelector("[data-add-to-cart-text]");
            const loadingIcon = addButton.querySelector("[data-loading-icon]");
            if (addToCartText) addToCartText.classList.add("hidden");
            if (loadingIcon) loadingIcon.classList.remove("hidden");
            return;
          }

          this.classList.remove("loading");
          module?.classList.remove("is-loading");
          if (!addButton) return;

          addButton.classList.remove("loading");
          addButton.removeAttribute("aria-busy");

          const addToCartText = addButton.querySelector("[data-add-to-cart-text]");
          const loadingIcon = addButton.querySelector("[data-loading-icon]");
          if (loadingIcon) loadingIcon.classList.add("hidden");
          if (addToCartText) addToCartText.classList.remove("hidden");
        }

        async fetchVariantData(productFetchUrl, context) {
          try {
            this.setVariantLoadingState(true);
            await this.fetchProductData(productFetchUrl);
            this.updateDOMWithData(context);
          } catch (error) {
            console.error(`Failed to fetch variant data:`, error);
          } finally {
            this.setVariantLoadingState(false);
            if (this.currentVariant) {
              this.toggleAddButton(this.currentVariant.available);
            }
          }
        }

        extractProductData(data) {
          /* ===== Parse the fetched data and return the new product data ===== */
          const parser = new DOMParser();
          const htmlDocument = parser.parseFromString(data, "text/html");
          const productQuickBuy =
            htmlDocument.querySelector("product-quick-buy") ||
            htmlDocument.querySelector("product-information");
          const quickViewContent = htmlDocument.querySelector(
            "template[data-quick-view-product]"
          )?.content;

          const quickViewContentInformation =
            quickViewContent?.querySelector("product-quick-buy");

          // Inside productQuickBuy, we want to replace the <h1> element with an <a> element with the url of the product
          const productTitle = productQuickBuy.querySelector("h1");
          if (productTitle) {
            const productLink = document.createElement("a");
            productLink.href =
              productQuickBuy.getAttribute("data-url") || this.mainProductURL;
            productLink.textContent = productTitle.textContent;
            productLink.classList.add(
              "full-unstyled-link",
              "product-grid--title",
              "product-details-product-title",
              "font-semibold"
            );
            productLink.setAttribute("data-url", productLink.href);

            // Replace the h1 in productQuickBuy with the new link
            productTitle.parentNode.replaceChild(productLink, productTitle);
          }

          const productDataElement =
            this.isQuickView && quickViewContentInformation
              ? quickViewContentInformation
              : productQuickBuy;

          console.log("Extracted productQuickBuy:", productQuickBuy);
          console.log(
            "Found media-gallery:",
            htmlDocument.querySelector("media-gallery")
          );

          // Always try to extract media-gallery if it exists, regardless of context
          const productMedia = htmlDocument.querySelector("media-gallery");
          const quickViewMedia =
            quickViewContent?.querySelector("media-gallery");
          const productMediaElement =
            this.isQuickView && quickViewMedia ? quickViewMedia : productMedia;

          if (this.isCombinedListing) {
            // For combined listing pages (main product page), create a div with both media and info
            const productDiv = document.createElement("div");
            productDiv.setAttribute(
              "data-url",
              productQuickBuy?.getAttribute("data-url")
            );

            if (productMediaElement) {
              productDiv.appendChild(productMediaElement);
            }

            if (productDataElement) {
              productDiv.appendChild(productDataElement);
            }

            console.log(
              "Returning combined listing data:",
              productDiv.outerHTML
            );
            return productDiv.outerHTML;
          } else {
            // For non-combined listing pages (like featured products), return both media and info if available
            if (productMediaElement && productDataElement) {
              const productDiv = document.createElement("div");
              productDiv.setAttribute(
                "data-url",
                productQuickBuy?.getAttribute("data-url")
              );
              productDiv.appendChild(productMediaElement);
              productDiv.appendChild(productDataElement);

              console.log(
                "Returning non-combined listing data with media:",
                productDiv.outerHTML
              );
              return productDiv.outerHTML;
            } else if (productMediaElement) {
              // If only media exists, return it
              console.log(
                "Returning media gallery only:",
                productMediaElement.outerHTML
              );
              return productMediaElement.outerHTML;
            } else {
              // Fallback to product information only
              console.log(
                "Returning product information only:",
                productDataElement.outerHTML
              );
              return productDataElement.outerHTML;
            }
          }
        }

        handleResize() {
          /* ===== Handle resizing of the window ===== */
          if (window.Shopify.designMode) {
            // If we're in the theme editor we need to update the sticky form offset
            // We only do this in the editor because it's not necessary in the live site
            // because mobile devices can incorrectly trigger resize events when scrolling
            this.setStickyOffset();
          }
        }

        handleQuantityChange(event) {
          /* ===== Handle changes to the quantity input ===== */

          // Update the quantity input value
          this.productForm = this.queryInModule("product-form");
          this.formQuantityInput =
            this.productForm?.querySelector('[name="quantity"]');

          if (this.formQuantityInput && event.value) {
            if (event.sectionId && event.sectionId !== this.sectionId) return;
            this.formQuantityInput.value = event.value;
          }
        }

        setStickyOffset() {
          if (this.stickyContainer && this.stickyHeader) {
            // Set the top offset of the sticky form to the height of the sticky header
            this.stickyContainer.style.top = `${this.stickyHeader.offsetHeight}px`;
          }
        }

        async handleVariantChange(context) {
          /* ===== Handle changes to the variant ===== */

          if (context.sectionId) {
            this.sectionId = context.sectionId;
          }
          if (
            context.sectionId &&
            this.colorIds?.includes(this.sectionId) === true &&
            context.containerId === this.originalSectionId
          ) {
            // If the variant change was triggered by the media and the variant doesn't match
            // any of the options, we don't need to update the UI
            if (context.fromSlideChange) {
              const mediaVariantId =
                this.queryInModule(
                  `[data-swatch-variant-id="${context.variant.id}"]`
                ) ||
                this.queryInModule(
                  `[data-dropdown-variant-id="${context.variant.id}"]`
                );
              if (!mediaVariantId) return;
            }

            // Update the current variant based on the selected options
            this.currentVariant = context.variant;
            this.productFetchUrl = context.fetchURL;
            this.productUrl = context.productURL;

            // If we don't have a valid variant, handle it and return
            if (!this.currentVariant) {
              this.handleInvalidVariant();
              return;
            }

            if (!this.productFetchUrl || !this.productUrl) return;

            // If the variant is available, update the UI
            this.toggleAddButton(this.currentVariant.available);
            const isCached = this.dataCache.has(this.productFetchUrl);

            /*
        if (isCached && !window.Shopify.designMode) {
          this.updateDOMWithData(context);
        } else {
         */
            // If the data is not cached, fetch the product data and then update the UI
            await this.fetchVariantData(this.productFetchUrl, context);
            // }
          }
        }

        handleInvalidVariant() {
          /* ===== Handle an invalid variant ===== */
          this.toggleAddButton(false, { invalid: true });
          const addButton = this.productForm?.querySelector('[name="add"]');
          if (!addButton) return;
          const addButtonSpan = addButton.querySelector(
            "[data-add-to-cart-text]"
          );
          if (!addButtonSpan) return;

          addButtonSpan.textContent = addButtonSpan.getAttribute(
            "data-unavailable-text"
          );

          // If the variant is invalid, set the price to "Unavailable"
          const priceElement = this.queryInModule("[data-product-price]");
          if (!priceElement) return;
          const priceElementSpan = priceElement.querySelector(
            "span[data-price-text]"
          );
          if (!priceElementSpan) return;

          priceElementSpan.textContent = priceElementSpan.getAttribute(
            "data-unavailable-text"
          );
        }

        updateDOMWithData(context) {
          /* ===== Update the UI with the cached data ===== */
          if (this.enableURLUpdate) this.updateURL();

          const data = this.dataCache.get(context.fetchURL);
          const html = this.parseHTML(data);
          this.updateDOM(html, context);
        }

        parseHTML(data) {
          /* ===== Parse the fetched data into a DOM object ===== */
          return new DOMParser().parseFromString(data, "text/html");
        }

        updateDOM(html, context = {}) {
          /* ===== Update the DOM with the fetched data ===== */
          this.replaceElements(html, context);

          if (context.fromSlideChange) return;

          // Emit an event to let other components know the variant was updated
          eventBus.emit("variant:updated", {
            variant: this.currentVariant,
            sectionId: this.sectionId,
            isCombinedListing: context.isCombinedListing,
            fetchURL: this.productFetchUrl,
            productURL: this.productUrl,
          });
        }

        toggleBackInStockButton(show, variantId) {
          this.productForm = this.queryInModule("product-form");
          const bisWrapper = this.productForm?.querySelector("[data-back-in-stock]");
          if (!bisWrapper) return;
          bisWrapper.classList.toggle("hidden", !show);
          if (variantId) bisWrapper.dataset.variantId = variantId;
        }

        toggleAddButton(enable, options = {}) {
          /* ===== Toggle the add to cart button based on the variant availability ===== */
          this.productForm = this.queryInModule("product-form");
          const addButton = this.productForm?.querySelector('[name="add"]');
          if (!addButton) return;

          if (options.invalid) {
            addButton.classList.remove("hidden");
            addButton.toggleAttribute("disabled", true);
            this.toggleBackInStockButton(false);
            return;
          }

          if (enable) {
            addButton.classList.remove("hidden");
            addButton.toggleAttribute("disabled", false);
            this.toggleBackInStockButton(false);
            return;
          }

          addButton.classList.add("hidden");
          addButton.toggleAttribute("disabled", true);
          this.toggleBackInStockButton(true, this.currentVariant?.id);
        }

        updateURL() {
          /* ===== Update the URL with the current variant ID ===== */
          if (this.currentVariant) {
            window.history.replaceState({}, "", `${this.productFetchUrl}`);
          }
        }

        replaceElements(html, context = {}) {
          /* ===== Replace elements in the DOM with new elements ===== */
          if (!html) return;

          console.log("Section ID:", this.sectionId);
          console.log("Color IDs:", this.colorIds);
          console.log(
            "Color IDs includes section ID:",
            this.colorIds?.includes(this.sectionId)
          );
          console.log(
            "Container ID matches original:",
            context.containerId === this.originalSectionId
          );

          if (
            this.sectionId &&
            this.colorIds?.includes(this.sectionId) === true &&
            context.containerId === this.originalSectionId
          ) {
            const productQuickBuy =
              html.querySelector(
                `product-quick-buy[data-url="${context.productURL}"]`
              ) ||
              html.querySelector(
                `product-information[data-url="${context.productURL}"]`
              );
            if (!productQuickBuy) return;

            console.log("Context type:", context.type);
            console.log("Is grid item:", this.isGridItem);
            console.log("Context container ID:", context.containerId);
            console.log("Original section ID:", this.originalSectionId);

            if (context.type === "color") {
              if (this.isGridItem) {
                // const productWrapper = this.previousElementSibling;
                const parentCard = this.closest(".card-product");
                const productWrapper = parentCard
                  ? parentCard.querySelector(".grid-view-item-image")
                  : this.previousElementSibling;

                if (productWrapper) {
                  const productMedia = html.querySelector("media-gallery");
                  let newImages = [];

                  // Try different selectors to find images based on context
                  if (productMedia) {
                    // Try main product page structure first
                    newImages = productMedia.querySelectorAll(
                      ".product__media-list .swiper-wrapper .product__media img"
                    );

                    // If no images found, try alternative selectors
                    if (newImages.length === 0) {
                      // Try product card structure
                      newImages = productMedia.querySelectorAll(
                        ".product__media-list .swiper-wrapper img"
                      );
                    }

                    // If still no images, try a more generic approach
                    if (newImages.length === 0) {
                      newImages = productMedia.querySelectorAll("img");
                    }
                  }

                  console.log("Found newImages:", newImages);
                  console.log(
                    "Product media HTML structure:",
                    productMedia?.innerHTML
                  );

                  const swiperContainer = productWrapper.querySelector(
                    ".swiper-productCard .swiper-wrapper"
                  );

                  // replace badges
                  const newBadges =
                    productQuickBuy.querySelector(".product-badges");
                  if (newBadges) {
                    productWrapper.querySelector(
                      ".product-grid__badges"
                    ).innerHTML = newBadges.innerHTML;
                  }

                  //replace link
                  productWrapper.querySelector("a").href = context.productURL;

                  // replace main image
                  const firstImage = newImages[0];
                  const secondImage = newImages[1];
                  const mainImage = productWrapper.querySelector(
                    ".product-card__main-image .theme-img"
                  );
                  if (mainImage && firstImage) {
                    mainImage.srcset = firstImage.src;
                    mainImage.src = firstImage.src;
                  }
                  // Replace hover image (if exists, on homepage)
                  const hoverImage = productWrapper.querySelector(
                    ".product-card__image--secondary .theme-img"
                  );
                  if (hoverImage && secondImage && secondImage.src) {
                    hoverImage.srcset = secondImage.src;
                    hoverImage.src = secondImage.src;
                  }

                  // replace slider
                  // Create a DocumentFragment to batch updates for performance
                  if (newImages.length > 0) {
                    const fragment = document.createDocumentFragment();
                    newImages.forEach((item) => {
                      const slide = document.createElement("li");
                      slide.className = "swiper-slide";
                      const clonedImage = item.cloneNode(true);
                      slide.appendChild(clonedImage);
                      fragment.appendChild(slide);
                    });

                    if (swiperContainer) {
                      // Replace the current swiper-wrapper content with the new slides
                      swiperContainer.innerHTML = ""; // Clear the existing content
                      swiperContainer.appendChild(fragment);
                    }

                    if (productWrapper.swiper) {
                      // If Swiper instance exists, update it
                      productWrapper.swiper.update();
                    } else {
                      // Otherwise, initialize a new Swiper instance
                      const swiperOptions = {
                        slidesPerView: 1,
                        navigation: {
                          nextEl: ".swiper-button-next",
                          prevEl: ".swiper-button-prev",
                        },
                        pagination: {
                          el: ".swiper-pagination",
                          clickable: true,
                        },
                        loop: true,
                        breakpoints: {
                          769: {
                            initialSlide: 1,
                          },
                        },
                      };
                      new Swiper(
                        productWrapper.querySelector(".swiper-productCard"),
                        swiperOptions
                      );
                    }
                  }
                }
              } else {
                const productWrapper = this.closest(
                  "[data-product-content-wrapper]"
                );
                const productMedia = html.querySelector("media-gallery"); // The media-gallery comes from the product-quick-buy component
                const currentProductMedia =
                  productWrapper.querySelector("media-gallery") ||
                  productWrapper.querySelector("product-media");

                if (productMedia && currentProductMedia)
                  currentProductMedia.replaceWith(productMedia);
              }
            }

            const currentElements = this.queryAllInModule("[data-update-id]");
            const newElements = Array.from(
              productQuickBuy.querySelectorAll("[data-update-id]")
            );
            // Update existing elements and track their order
            currentElements.forEach((currentElement) => {
              const currentUpdateId =
                currentElement.getAttribute("data-update-id");
              const newElement = productQuickBuy.querySelector(
                `[data-update-id="${currentUpdateId}"]`
              );
              if (newElement) {
                // Replace the element if it has the data-replace-content attribute, otherwise update the innerHTML
                if (
                  this.isGridItem &&
                  newElement.getAttribute("data-update-id") ===
                    "submit-buy_buttons"
                ) {
                  newElement.querySelector(
                    "span[data-add-to-cart-text]"
                  ).textContent = this.wording;
                }
                newElement.hasAttribute("data-replace-content")
                  ? currentElement.replaceWith(newElement)
                  : (currentElement.innerHTML = newElement.innerHTML);
              }
              // find in each element the input and the label to add to the id the value context.containerId
              const inputs = currentElement.querySelectorAll("input");
              const labels = currentElement.querySelectorAll("label");
              const scripts = currentElement.querySelectorAll("script");
              inputs.forEach((input) => {
                const inputId = input.getAttribute("id");
                if (!inputId) return;
                const newId = inputId + "-" + context.containerId;
                input.setAttribute("id", newId);
              });
              labels.forEach((label) => {
                const labelFor = label.getAttribute("for");
                if (!labelFor) return;
                label.setAttribute("for", labelFor + "-" + context.containerId);
              });
              scripts.forEach((script) => {
                const resource = script.getAttribute("data-resource");
                if (!resource) return;
                script.setAttribute(
                  "data-resource",
                  resource + "-" + context.containerId
                );
              });
            });

            const swymWishlist = this.queryInModule(".swym-button");
            if (swymWishlist) {
              const previousId = swymWishlist.getAttribute("data-product-id");
              swymWishlist.classList.remove(`product_${previousId}`);
              swymWishlist.classList.add(`product_${context.sectionId}`);
              swymWishlist.setAttribute("data-product-id", context.sectionId);
              swymWishlist.setAttribute("data-variant-id", context.variant.id);
              swymWishlist.setAttribute(
                "data-product-url",
                `https://stella-forest-shop.myshopify.com${context.fetchURL}`
              );
            }
            if (this.isGridItem) {
              this.openQuickBuy = this.querySelector(".quickAddJs");
              this.closeQuickBuy = this.queryInModule(".quickAddCloseJs");
              if (this.openQuickBuy) {
                this.openQuickBuy.addEventListener(
                  "click",
                  this.openQuickBuyModal.bind(this)
                );
              }
              if (this.closeQuickBuy) {
                this.closeQuickBuy.addEventListener(
                  "click",
                  this.closeQuickBuyModal.bind(this)
                );
              }
            }
            if (!this.isGridItem) {
              // Add new elements in the correct order
              newElements.forEach((newElement) => {
                const newUpdateId = newElement.getAttribute("data-update-id");
                const existingElement = this.querySelector(
                  `[data-update-id="${newUpdateId}"]`
                );

                if (!existingElement) {
                  // Determine the correct position to insert the new element
                  let inserted = false;
                  for (let i = 0; i < currentElements.length; i++) {
                    const currentElement = currentElements[i];
                    const currentUpdateId =
                      currentElement.getAttribute("data-update-id");
                    if (currentUpdateId > newUpdateId) {
                      currentElement.insertAdjacentElement(
                        "beforebegin",
                        newElement.cloneNode(true)
                      );
                      inserted = true;
                      break;
                    }
                  }
                  // If not inserted, append to the end
                  if (!inserted) {
                    this.appendChild(newElement.cloneNode(true));
                  }
                }
              });
            }

            /*if (this.isCombinedListing && context.isCombinedListing) {
          const productWrapper = this.closest('[data-product-content-wrapper]');
          const productMedia = html.querySelector('product-media');
          const currentProductMedia = productWrapper?.querySelector('product-media');
          if (productMedia && currentProductMedia) currentProductMedia.replaceWith(productMedia);
        }*/

            if (window.Shopify && window.Shopify.PaymentButton) {
              window.Shopify.PaymentButton.init();
            }
          }
        }
      }
    );
  }
  /******/
})();
